export enum UserRole {
  Operator = 'Operator',
  Supervisor = 'Supervisor',
  Admin = 'Admin',
  RoTec = 'RoTec',
}
